export type PageGroup =
  | '城市与小程序'
  | '产品与套餐'
  | 'CMS 内容'
  | '订单'
  | '支付路由'
  | '消息'
  | '会员与营销'
  | '渠道与结算'
  | '财务与报表'
  | '系统与发布';

export interface AdminPageDefinition {
  id: string;
  title: string;
  path: string;
  group: PageGroup;
}

const pages: Array<[string, string, string, PageGroup]> = [
  ['ADM-A01', '后台登录', '/admin/login', '系统与发布'],
  ['ADM-A02', '经营总览', '/admin/dashboard', '系统与发布'],
  ['ADM-A03', '实时交易监控', '/admin/transactions/live', '系统与发布'],
  ['ADM-A04', '运营待办中心', '/admin/workbench/todos', '系统与发布'],
  ['ADM-A05', '全局搜索', '/admin/search', '系统与发布'],
  ['ADM-A06', '后台消息告警中心', '/admin/alerts', '系统与发布'],
  ['ADM-A07', '我的权限与数据范围', '/admin/me/access', '系统与发布'],
  ['ADM-A08', '审计概览', '/admin/audit/overview', '系统与发布'],
  ['ADM-A09', '个人资料与密码', '/admin/me/profile', '系统与发布'],
  ['ADM-B01', '城市管理', '/admin/cities', '城市与小程序'],
  ['ADM-B02', '城市详情', '/admin/cities/:id', '城市与小程序'],
  ['ADM-B03', '服务区域与景点', '/admin/cities/:id/poi', '城市与小程序'],
  ['ADM-B04', '小程序矩阵', '/admin/apps', '城市与小程序'],
  ['ADM-B10', '新增小程序', '/admin/apps/new', '城市与小程序'],
  ['ADM-B05', '小程序配置', '/admin/apps/:id/settings', '城市与小程序'],
  ['ADM-B06', '城市覆盖', '/admin/apps/:id/cities', '城市与小程序'],
  ['ADM-B07', '产品覆盖', '/admin/apps/:id/products', '城市与小程序'],
  ['ADM-B08', '客服配置', '/admin/apps/:id/customer-service', '城市与小程序'],
  ['ADM-B11', '收款商户', '/admin/apps/:id/payment-merchants', '城市与小程序'],
  ['ADM-B09', '运行状态', '/admin/apps/status', '城市与小程序'],
  ['ADM-C01', '产品管理', '/admin/products', '产品与套餐'],
  ['ADM-C02', '产品基础信息', '/admin/products/:id/basic', '产品与套餐'],
  ['ADM-C03', '行程配置', '/admin/products/:id/itinerary', '产品与套餐'],
  ['ADM-C04', 'SKU 套餐', '/admin/products/:id/skus', '产品与套餐'],
  ['ADM-C05', 'SKU 详情', '/admin/skus/:id', '产品与套餐'],
  ['ADM-C06', '服务项配置', '/admin/skus/:id/service-items', '产品与套餐'],
  ['ADM-C07', '预订与退款规则', '/admin/products/:id/booking-refund', '产品与套餐'],
  ['ADM-C08', '标签与排序', '/admin/products/tags-sort', '产品与套餐'],
  ['ADM-C09', '小程序覆盖', '/admin/products/:id/app-coverage', '产品与套餐'],
  ['ADM-C10', '发布检查', '/admin/products/:id/publish-check', '产品与套餐'],
  ['ADM-D01', '页面模板', '/admin/cms/templates', 'CMS 内容'],
  ['ADM-D02', '可视化编辑器', '/admin/cms/editor/:pageId', 'CMS 内容'],
  ['ADM-D03', '组件属性', '/admin/cms/editor/:pageId/properties', 'CMS 内容'],
  ['ADM-D04', '页面图层', '/admin/cms/editor/:pageId/layers', 'CMS 内容'],
  ['ADM-D05', '受控动作', '/admin/cms/editor/:pageId/actions', 'CMS 内容'],
  ['ADM-D06', '城市覆盖页', '/admin/cms/city-overrides', 'CMS 内容'],
  ['ADM-D07', '产品详情模板', '/admin/cms/product-detail-template', 'CMS 内容'],
  ['ADM-D08', '页面预览', '/admin/cms/preview', 'CMS 内容'],
  ['ADM-D09', '发布版本', '/admin/cms/releases', 'CMS 内容'],
  ['ADM-D10', '版本差异', '/admin/cms/releases/:id/diff', 'CMS 内容'],
  ['ADM-E01', '订单管理', '/admin/orders', '订单'],
  ['ADM-E03', '待支付订单', '/admin/orders/pending-payment', '订单'],
  ['ADM-E04', '待补资料订单', '/admin/orders/need-trip-info', '订单'],
  ['ADM-E05', '待运营确认订单', '/admin/orders/pending-confirm', '订单'],
  ['ADM-E02', '订单详情', '/admin/orders/:id', '订单'],
  ['ADM-E06', '人工履约回填', '/admin/orders/:id/fulfillment', '订单'],
  ['ADM-E07', '订单沟通日志', '/admin/orders/:id/communications', '订单'],
  ['ADM-E08', '退款申请处理', '/admin/refunds', '订单'],
  ['ADM-E09', '售后工单', '/admin/after-sales', '订单'],
  ['ADM-G01', '支付商户', '/admin/payments/merchants', '支付路由'],
  ['ADM-G02', '商户详情', '/admin/payments/merchants/:id', '支付路由'],
  ['ADM-G03', 'App 商户绑定', '/admin/payments/bindings', '支付路由'],
  ['ADM-G04', '支付路由规则', '/admin/payments/routes', '支付路由'],
  ['ADM-G05', '商户健康', '/admin/payments/health', '支付路由'],
  ['ADM-G06', '健康事件详情', '/admin/payments/health/events/:id', '支付路由'],
  ['ADM-G07', '支付流水', '/admin/payments/transactions', '支付路由'],
  ['ADM-G08', '支付失败', '/admin/payments/failures', '支付路由'],
  ['ADM-G09', '退款流水', '/admin/payments/refunds', '支付路由'],
  ['ADM-G10', '自动保护记录', '/admin/payments/protection', '支付路由'],
  ['ADM-I01', '消息模板', '/admin/messages/templates', '消息'],
  ['ADM-I02', '消息发送记录', '/admin/messages/tasks', '消息'],
  ['ADM-I03', '用户订阅状态', '/admin/messages/subscriptions', '消息'],
  ['ADM-F01', '会员列表', '/admin/members', '会员与营销'],
  ['ADM-F02', '会员 360 详情', '/admin/members/:id', '会员与营销'],
  ['ADM-F03', '会员行为时间线', '/admin/members/:id/timeline', '会员与营销'],
  ['ADM-F04', '会员标签分群', '/admin/members/tags-segments', '会员与营销'],
  ['ADM-F05', '转化漏斗', '/admin/members/funnel', '会员与营销'],
  ['ADM-F06', '会员偏好分析', '/admin/members/preferences', '会员与营销'],
  ['ADM-F07', '支付放弃人群', '/admin/members/payment-abandonment', '会员与营销'],
  ['ADM-F08', '会员导出隐私', '/admin/members/privacy-export', '会员与营销'],
  ['ADM-H03', '支付挽回策略', '/admin/marketing/payment-rescue', '会员与营销'],
  ['ADM-H04', '支付挽回漏斗', '/admin/marketing/payment-rescue/funnel', '会员与营销'],
  ['ADM-H01', '优惠券活动', '/admin/marketing/coupons', '会员与营销'],
  ['ADM-H02', '优惠券规则编辑', '/admin/marketing/coupons/:id', '会员与营销'],
  ['ADM-H05', '渠道组织树', '/admin/channels/tree', '渠道与结算'],
  ['ADM-H06', '渠道详情', '/admin/channels/:id', '渠道与结算'],
  ['ADM-H07', '推广员管理', '/admin/promoters', '渠道与结算'],
  ['ADM-H08', '推广链接二维码', '/admin/promotion-links', '渠道与结算'],
  ['ADM-H09', '佣金规则', '/admin/commissions/rules', '渠道与结算'],
  ['ADM-H10', '佣金结算批次', '/admin/commissions/settlement-batches', '渠道与结算'],
  ['ADM-I06', '渠道结算', '/admin/finance/channel-settlements', '渠道与结算'],
  ['ADM-E10', '订单导出任务', '/admin/orders/exports', '财务与报表'],
  ['ADM-I04', '订单利润', '/admin/finance/order-profit', '财务与报表'],
  ['ADM-I05', '支付对账', '/admin/finance/reconciliation', '财务与报表'],
  ['ADM-I07', 'App 城市经营报表', '/admin/reports/app-city-performance', '财务与报表'],
  ['ADM-I08', '统一导出中心', '/admin/exports', '财务与报表'],
  ['ADM-J01', '系统用户', '/admin/security/users', '系统与发布'],
  ['ADM-J02', '角色管理', '/admin/security/roles', '系统与发布'],
  ['ADM-J03', '菜单与操作', '/admin/security/permission-matrix', '系统与发布'],
  ['ADM-J04', '经营数据范围', '/admin/security/data-scopes', '系统与发布'],
  ['ADM-J05', '隐私与金额', '/admin/security/field-policies', '系统与发布'],
  ['ADM-J06', '敏感操作', '/admin/security/high-risk-grants', '系统与发布'],
  ['ADM-J11', '组织架构', '/admin/security/organizations', '系统与发布'],
  ['ADM-J07', '系统设置', '/admin/system/settings', '系统与发布'],
  ['ADM-J08', '多小程序构建发布中心', '/admin/releases', '系统与发布'],
  ['ADM-J09', '发布详情审核门禁', '/admin/releases/:id', '系统与发布'],
  ['ADM-J10', '日志备份监控配置', '/admin/ops/config', '系统与发布'],
];

export const adminPages: AdminPageDefinition[] = pages.map(([id, title, path, group]) => ({
  id,
  title,
  path,
  group,
}));

export function matchPage(pathname: string) {
  const employeeEditor = /^\/admin\/security\/users\/(new|([^/]+)\/edit)\/?$/u.exec(pathname);
  if (employeeEditor) {
    const page = adminPages.find((item) => item.id === 'ADM-J01')!;
    return {
      page: { ...page, title: employeeEditor[2] ? '编辑员工' : '新建员工' },
      params: employeeEditor[2]
        ? { staffMode: 'edit', userId: decodeURIComponent(employeeEditor[2]) }
        : { staffMode: 'new' },
    };
  }
  const orderedPages = [...adminPages].sort(
    (left, right) => Number(left.path.includes(':')) - Number(right.path.includes(':')),
  );
  for (const page of orderedPages) {
    const names: string[] = [];
    const pattern = page.path.replace(/:[^/]+/g, (token) => {
      names.push(token.slice(1));
      return '([^/]+)';
    });
    const match = pathname.match(new RegExp(`^${pattern}/?$`));
    if (match) {
      const params = Object.fromEntries(
        names.map((name, index) => [name, decodeURIComponent(match[index + 1] ?? '')]),
      );
      return { page, params };
    }
  }
  return undefined;
}

export function pathFor(pageId: string, params: Record<string, string> = {}) {
  const page = adminPages.find((item) => item.id === pageId);
  if (!page) return '/admin/cities';
  return page.path.replace(/:([^/]+)/g, (_, key: string) => encodeURIComponent(params[key] ?? ''));
}
